import type { ReactNode } from 'react'
import { TokenIcon } from './holdings-table'
import { CustodyLogo } from './custody-logo'
import { tokenLogo } from '@/lib/default-tokens'
import type { StrategyView } from '@/lib/api-types'

type Noticed = Pick<StrategyView, 'kind' | 'side' | 'exchange'> & { token: { address: string; symbol: string | null; imageUrl?: string | null } }

/**
 * The quick notice for a strategy that just changed (John, Nov 5 2026: "just
 * show it on the screen at the bottom… a logo of the token… keep it short"):
 * the token's logo, "HELL DCA Sell paused", the exchange's mark. A chip in
 * the activity bar for a few seconds, see useToast.
 */
export function strategyNotice(s: Noticed, did: string): { icon: ReactNode; title: ReactNode } {
  const ticker = (s.token.symbol ?? 'token').toUpperCase()
  const kind = `${s.kind === 'limit' ? 'Limit' : 'DCA'} ${s.side === 'sell' ? 'Sell' : 'Buy'}`
  return {
    icon: <TokenIcon symbol={ticker} imageUrl={tokenLogo(s.token.address, s.token.imageUrl ?? undefined)} address={s.token.address} size="size-5" />,
    title: (
      <span className="inline-flex items-center gap-1.5">
        {ticker} {kind} {did}
        {s.exchange ? <CustodyLogo custody={s.exchange} size="size-3.5" /> : null}
      </span>
    ),
  }
}

/** how long a quick notice stays */
export const NOTICE_MS = 3_500
